import axios from "axios";
import router from "@/router";
import { MessageBox, Message, Loading } from "element-ui";
import store from "@/store";
import tool from "@/utils/Tool";
// 后续功能上线测试
// import FingerprintJS from "@fingerprintjs/fingerprintjs";
// 在文件加载时提前初始化并获取设备指纹。利用 Promise 缓存机制，
// 无论发起多少次请求，指纹只在第一次计算，后续直接复用，避免性能浪费。
// const visitorIdPromise = FingerprintJS.load()
//   .then((fp) => fp.get())
//   .then((result) => result.visitorId)
//   .catch((err) => {
//     console.error("获取设备指纹失败:", err);
//     return null;
//   });

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 20000, // request timeout
});
let $_loading = null;
// request interceptor
service.interceptors.request.use(
  async (config) => {
    if (config.loading === undefined) {
      $_loading = Loading.service({
        fullscreen: true,
        lock: false,
        text: "正在加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.2)",
      });
    } else if (config.loading && typeof config.loading === "string") {
      $_loading = Loading.service({
        target: document.querySelector(config.loading),
      });
    }
    if (localStorage.getItem("token")) {
      config.headers.Authorization = "Bearer " + localStorage.getItem("token");
    }
    config.headers.platform = 7;
    config.headers.agentid = 1;
    config.headers.appsource = 1;
    if (process.env.VUE_APP_ENV === "nx") {
      config.headers["school-code"] = "nanxiong";
    }
    if (window.nw) {
      config.headers.version = nw.App.manifest.version;
    } else {
      // const visitorId = await visitorIdPromise;
      // if (visitorId) {
      //   config.headers.deviceid = visitorId;
      // }
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    $_loading.close();
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 401) {
      // 重定向到登录页面
      tool.logout();
      return Promise.reject(new Error("Unauthorized")); // 这里直接中断
    } else if (res.code === 502) {
      router.push({
        path: "/502",
      });
    } else if (res.code === -200) {
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000,
      });
      return res;
    } else if (res.code === 400) {
      Message({
        message: res.message || "Error",
        type: "error",
        duration: 3 * 1000,
      });
      return res;
    } else {
      return res;
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      // return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  (error) => {
    $_loading.close();
  }
);

export default service;
